import React, { useMemo } from "react";
import { useDispatch } from "react-redux";

import { removeMusic } from "../../thunks/editor/musicThunks";
import { Dropdown } from "../common/dropdown";

const MusicMenu = ({ id, className, handleClose, isAudio }) => {
  const dispatch = useDispatch();

  const handleRemove = () => {
    handleClose();
    dispatch(removeMusic(id, isAudio));
  };

  const slideMenu = useMemo(
    () => [
      {
        title: "Remove",
        onClick: handleRemove,
        icon: "/tool/dashboard/static/images/icons/tools/delete.svg",
      },
    ],
    []
  );
  return <Dropdown menu={slideMenu} className={className} />;
};

export default MusicMenu;
